import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Link';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { useTranslation } from 'react-i18next';
import MoreIcon from '@material-ui/icons/ExpandMore';
import { useOrganizations, useProperties, useFields, useEvents, useDevices } from 'hooks';

const OrganizationPicker = ({ variant, unsetLabel, unsetButtonLabel, showDefault }) => {
  const { organizations, selectedOrganization, setSelectedOrganization } = useOrganizations();
  const { setSelectedProperty, fetchProperties } = useProperties();
  const { fetchDevices } = useDevices();
  const { setSelectedField, fetchFields } = useFields();
  const { setFilter, fetchEvents, filters } = useEvents();

  const { t } = useTranslation();

  const getOrganizationItems = (popupState) => {
    const organizationItems = [
      <MenuItem
        key="none"
        onClick={(e) => {
          popupState.close(e);
          setSelectedOrganization();
          setSelectedField(undefined);
          setSelectedProperty(undefined);
          setFilter({ organization_id: '' });
          fetchEvents({ ...filters, organization_id: '' });
        }}
      >
        {t(unsetLabel)}
      </MenuItem>,
    ];
    _.forEach(organizations, (organization, organizationID) => {
      organizationItems.push(
        <MenuItem
          key={organizationID}
          onClick={(e) => {
            popupState.close(e);
            setSelectedOrganization(organization.id);
            setSelectedField(undefined);
            setSelectedProperty(undefined);
            fetchDevices(organization.id);
            fetchProperties(organization.id);
            fetchFields();
            setFilter({ organization_id: organization.id });
            fetchEvents({ ...filters, organization_id: organization.id });
          }}
        >
          {organization.name}
        </MenuItem>
      );
    });
    return organizationItems;
  };

  if (organizations && organizations.length != 0) {
    if (showDefault) {
      return <Typography variant={variant}>{organizations[0].name}</Typography>;
    }
  } else {
    return <span style={{ display: 'none' }} />;
  }

  if (showDefault && organizations && organizations.length > 0) {
    return <Typography variant={variant}>{organizations[0].name}</Typography>;
  }

  return (
    <PopupState variant="popover" popupId="property-popup-menu">
      {(popupState) => (
        <>
          <Button {...bindTrigger(popupState)}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant={variant}>
                {selectedOrganization && selectedOrganization.name ? selectedOrganization.name : t(unsetButtonLabel)}
              </Typography>
              <MoreIcon fontSize="small" color="secondary" style={{ marginLeft: 4, marginTop: 4 }} />
            </div>
          </Button>
          <Menu {...bindMenu(popupState)}>{getOrganizationItems(popupState)}</Menu>
        </>
      )}
    </PopupState>
  );
};
OrganizationPicker.propTypes = {
  variant: PropTypes.string,
  unsetButtonLabel: PropTypes.string,
  unsetLabel: PropTypes.string,
  showDefault: PropTypes.bool, // if there is only one property, show the label or no-op
};
OrganizationPicker.defaultProps = {
  variant: 'subtitle1',
  unsetButtonLabel: 'property_organization',
  unsetLabel: 'none',
  showDefault: false,
};
export default OrganizationPicker;
